import type { ApiEnvelope } from "@triple-h/shared";

export class PublicApiError extends Error {
  status: number;
  code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export async function publicApi<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body) headers.set("Content-Type", "application/json");
  const response = await fetch(`/api/v1${path}`, { ...init, headers });
  const body = await response.json().catch(() => ({ error: { code: "INVALID_RESPONSE", message: "The server returned an invalid response." } }));
  if (!response.ok) {
    throw new PublicApiError(response.status, body.error?.code || "REQUEST_FAILED", body.error?.message || "Request failed.");
  }
  return (body as ApiEnvelope<T>).data;
}

export async function publicApiPage<T>(path: string): Promise<ApiEnvelope<T>> {
  const response = await fetch(`/api/v1${path}`);
  const body = await response.json().catch(() => ({ error: { code: "INVALID_RESPONSE", message: "The server returned an invalid response." } }));
  if (!response.ok) {
    throw new PublicApiError(response.status, body.error?.code || "REQUEST_FAILED", body.error?.message || "Request failed.");
  }
  return body as ApiEnvelope<T>;
}
